import { css } from "emotion";
import { max } from "../../utils/CssUtils";

const H4 = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  maxWidth = "none",
  marginBottomMobile = 0,
  marginTopMobile = 0,
  semiBold = true,
  children
}) => {
  const styles = css({
    fontWeight: semiBold ? 600 : 400,
    fontSize: 20,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    [max(breakpoint)]: {
      fontSize: 18,
      marginTop: marginTopMobile,
      marginBottom: marginBottomMobile
    }
  });

  return <h4 className={styles}>{children}</h4>;
};

export default H4;
